import React from "react";
import "./services.css";
import { Card, Container, Grid, Typography } from "@material-ui/core";
import Footer from "../footer/footer";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import UIDesign from "../images/UI.png";
import WebDevelopment from "../images/webDevelopment.png";
import MobileApp from "../images/mobileDevelopment.png";
import WebDesign from "../images/webDesign.png";
import GraphicDesign from "../images/graphicDesign.png";
import ServiceBack from "../images/servicesBack.png";
import { StyledButton } from "../helpers/button";

const ServiceCards = ({ image, title, content }) => {
  return (
    <div class="card">
      <div class="wrapper">
        <div class="cardImage">
          <img src={image} />
        </div>
        <div class="cardContent">
          <h2 class="cardHeader">{title}</h2>
          <ul>
            {content.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const services1 = [
  {
    title: "UI UX Design",
    image: UIDesign,
    content: ["Landing Page Design", "Dashboard Design", "Application Design"]
  },
  {
    title: "Mobile App Development",
    image: MobileApp,
    content: [
      "All type of Mobile Apps",
      "Real Time Apps",
      "Help in Tech Stack Upgradation"
    ]
  }
];

const services2 = [
  {
    title: "Website Design",
    image: WebDesign,
    content: [
      "Complex Feature Layouts",
      "Custom Requirement Designing",
      "Tech Stack improvement"
    ]
  },
  {
    title: "Web Development",
    image: WebDevelopment,
    content: [
      "All type of web development",
      "Speciality in Ecommerce Apps",
      "Dashboard solutions"
    ]
  },
  {
    title: "Graphics Design",
    image: GraphicDesign,
    content: ["Logo Design", "Poster Design", "Banner Desigin"]
  }
];

export default function App() {
  return (
    <div className={"serviceContainer"} id="services">
      {/* <img style={{position:"absolute",height:"100%",width:"100%",background:red}} src={ServiceBack}/> */}
      <div className={"serviceCardContainer"}>
        <div className={"serviceListContainer"}>
          {services1.map((item) => (
            <ServiceCards
              image={item.image}
              content={item.content}
              title={item.title}
            />
          ))}
          {/* <ServiceCards />
          <ServiceCards /> */}
        </div>
        <div className={"serviceListContainer"}>
          {services2.map((item) => (
            <ServiceCards
              image={item.image}
              content={item.content}
              title={item.title}
            />
          ))}
        </div>
      </div>
      <div className={"serviceListContainer"}>
        <div className={"serviceDetailContainer"}>
          <h1 className="serviceTitle">Services</h1>

          <h1>The Best Digital Agency</h1>

          <div class="serviceDetails">
            <h3>Services we Offer</h3>
            <p>
              We offer wide varierty of services that helps to grow your
              business. Let's work as a team and create a brand.
            </p>
            <ul>
              <li>UI UX Design</li>
              <li>Web Design</li>
              <li>Web Development</li>
              <li>Mobile App Development</li>
              <li>Hybrid App Development</li>
              <li>Some more</li>
            </ul>
            <StyledButton height={"45px"}>Get A Deal Now</StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}
